// export const round = (num: number | null) =>
//   num ? Math.round((num + Number.EPSILON) * 100) / 100 : num;

export const round = (num: number | null) =>
  num !== null ? Math.round(num) : num;
